import { Spacer } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import { EventDetail } from 'model/modules/events/eventDetail';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import EventCategoriesSidebarContainer from 'presentation/containers/modules/event/EventCategoriesSidebarContainer';
import { FC } from 'react';
import EventDetailDateTimeInfo from './sections/EventDetailDateTimeInfo';
import EventDetailNextEventNotScheduled from './sections/EventDetailNextEventNotScheduled';

interface Props {
  data: EventDetail;
}

const EventDetailSidebar: FC<Props> = ({ data }) => {
  let sidebar =
    data.category.hasNextEvent && data.category.nextEvent ? (
      <EventDetailDateTimeInfo
        startDate={data.category.nextEvent.startDate}
        endDate={data.category.nextEvent.endDate}
        location={data.category.nextEvent.location}
        eventId={data.category.nextEvent.id}
      />
    ) : (
      <EventDetailNextEventNotScheduled categoryId={data.category.id} />
    );
  sidebar = (
    <>
      <EventCategoriesSidebarContainer activeCategoryId={data.category.id} />
      <Spacer h="20px" />
      {sidebar}
      <PersonalManagerChatCard
        mt="20px"
        roomType={ChatRoomType.CommunityManager}
      />
    </>
  );

  return sidebar;
};

export default EventDetailSidebar;
